export enum CommentFilter {
    ALL = 'all',
    WITH_COMMENT = 'with_comment',
    WITHOUT_COMMENT = 'without_comment'
}
